// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-request {
  border: dotted #999290;
  border-width: 0 0 1px 0;
  padding: 10px 0;
  margin-bottom: 10px;
}
.change-request .change-request-title {
  font-weight: 600;
}
.change-request .change-request-text {
  white-space: pre-line;
  font-style: italic;
}
.change-request .change-request-text:before {
  content: '"';
}
.change-request .change-request-text:after {
  content: '"';
}
.va-trainee-day-calculator th,
.va-trainee-day-calculator-total th {
  font-weight: normal;
  padding-right: 4px;
  color: #4a4a4a;
}
.va-trainee-day-calculator label.total,
.va-trainee-day-calculator-total label.total {
  display: inline;
}
.va-budget {
  color: #4a4a4a;
}
.va-budget .summing-table,
.va-budget .budget-summary {
  width: 782px;
  text-align: left;
}
.va-budget .summing-table tbody tr:last-child td,
.va-budget .budget-summary tbody tr:last-child td {
  padding-bottom: 10px;
}
.va-budget .summing-table .soresu-money-field input[type=text],
.va-budget .budget-summary .soresu-money-field input[type=text] {
  margin: 0 6px 4px 0;
}
.va-budget .summing-table .soresu-text-field input[type=text],
.va-budget .budget-summary .soresu-text-field input[type=text] {
  margin: 0 4px 4px 0;
}
.va-budget .summing-table .soresu-text-area textarea,
.va-budget .budget-summary .soresu-text-area textarea {
  margin: 0;
  width: 381px;
  height: 24px;
}
.va-budget .summing-table .soresu-text-area .length-left,
.va-budget .budget-summary .soresu-text-area .length-left {
  display: none;
}
.va-budget .summing-table .money:after,
.va-budget .budget-summary .money:after {
  content: "\\00A0€";
}
.va-budget .summing-table .error,
.va-budget .budget-summary .error {
  color: #c9302c;
}
.va-budget .summing-table {
  margin-top: 13px;
}
.va-budget .summing-table caption {
  margin: 8px 0 16px 0;
  font-size: 18px;
  text-align: left;
  text-transform: uppercase;
}
.va-budget .summing-table thead tr {
  border-top: 10px transparent solid;
  border-bottom: 8px transparent solid;
}
.va-budget .summing-table tbody td {
  vertical-align: top;
  padding-bottom: 2px;
}
.va-budget .summing-table colgroup .label-column {
  width: 415px;
}
.va-budget .summing-table colgroup .description-column {
  width: 267px;
}
.va-budget .summing-table colgroup .amount-column {
  width: 100px;
}
.va-budget .summing-table .label-column.disabled {
  color: #807a78;
}
.va-budget .summing-table .amount-column {
  text-align: right;
}
.va-budget .summing-table tfoot {
  border-top: 1px solid #d9d9d9;
  font-weight: bold;
}
.va-budget .summing-table tfoot td {
  padding-top: 5px;
}
.va-budget .budget-summary {
  margin-top: 26px;
}
.va-budget .budget-summary-financing {
  overflow: hidden;
}
.va-budget .budget-summary h4 {
  font-weight: bold;
  margin: 14px 0;
}
.va-budget .budget-summary-financing-left {
  float: left;
  max-width: 50%;
}
.va-budget .budget-summary-financing-right {
  float: right;
  max-width: 50%;
}
.va-budget .budget-summary .amounts {
  margin-right: 20px;
}
.va-budget .budget-summary .percentages {
  margin-left: 20px;
}
.va-budget .budget-summary .amounts tbody tr:first-child td,
.va-budget .budget-summary .percentages tbody tr:first-child td {
  height: 50px;
}
.va-budget .budget-summary .amounts tbody tr:last-child td,
.va-budget .budget-summary .percentages tbody tr:last-child td {
  padding-top: 10px;
  padding-bottom: 0;
}
.va-budget .budget-summary .amount-label-column,
.va-budget .budget-summary .percentage-label-column {
  padding-right: 20px;
}
.va-budget .budget-summary .amount-value-column,
.va-budget .budget-summary .percentage-value-column {
  min-width: 120px;
  text-align: right;
}
.va-budget .budget-summary .soresu-money-field {
  margin: 0;
}
.va-budget .budget-summary .soresu-money-field input[type=text] {
  margin: 0;
}
.va-budget .budget-summary .soresu-money-field:after {
  content: "\\00A0€";
  margin-left: 4px;
}
.va-budget .budget-summary .percentage:after {
  content: "\\00A0%";
}
.va-budget .budget-summary .amount-value-column .money:not(.error):after {
  margin-left: 12px;
}
.soresu-growing-fieldset ol li.va-big-fieldset {
  margin: 20px 0 0 -90px;
}
.soresu-growing-fieldset .va-big-fieldset.disabled {
  color: #807a78;
}
.soresu-growing-fieldset .va-big-fieldset div.fieldset-elements {
  float: left;
  border-left: 1px solid #999290;
  border-right: 1px solid #999290;
  padding: 0 10px 0 21px;
  margin: 0 10px 40px 10px;
}
.soresu-growing-fieldset .va-big-fieldset div.fieldset-elements input[type=text],
.soresu-growing-fieldset .va-big-fieldset div.fieldset-elements input[type=email] {
  margin: 5px 10px 10px 0;
}
.soresu-growing-fieldset .va-big-fieldset div.fieldset-control {
  padding-top: 20px;
  overflow: hidden;
}
.soresu-preview .soresu-preview-growing-fieldset ol li.va-big-fieldset {
  margin: 0 0 40px -26px;
}
.soresu-preview .soresu-preview-growing-fieldset .va-big-fieldset div.fieldset-elements {
  border-left: 1px solid #999290;
  padding: 0 0 0 21px;
  margin: 0 0 0 20px;
}
.soresu-preview .va-budget .soresu-value {
  font-size: 16px;
}
.soresu-preview .va-budget .soresu-text-area.extra-extra-small,
.soresu-preview .va-budget .budget-summary .soresu-preview-element.extra-extra-small,
.soresu-preview .va-budget .soresu-text-area.extra-small,
.soresu-preview .va-budget .budget-summary .soresu-preview-element.extra-small,
.soresu-preview .va-budget .soresu-text-area.small,
.soresu-preview .va-budget .budget-summary .soresu-preview-element.small,
.soresu-preview .va-budget .soresu-text-area.medium,
.soresu-preview .va-budget .budget-summary .soresu-preview-element.medium,
.soresu-preview .va-budget .soresu-text-area.large,
.soresu-preview .va-budget .budget-summary .soresu-preview-element.large,
.soresu-preview .va-budget .soresu-text-area.extra-large,
.soresu-preview .va-budget .budget-summary .soresu-preview-element.extra-large {
  width: auto;
}
.soresu-preview .va-budget .budget-summary .amount-value-column .money:not(.error):after {
  margin-left: 0;
}
.va-register-number {
  margin-top: 5px;
  float: right;
}
.va-register-number .title {
  margin-right: 5px;
  font-weight: bold;
}
.h3 {
  display: block;
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.01em;
}
div.twocolumns {
  display: flex;
}
div.twocolumns > div:first-child {
  padding-right: 1rem;
}
div.twocolumns > div:not(:first-child) {
  border-left: 1px solid #979797;
  padding-left: 1rem;
}
.datepicker,
.datepicker:hover,
.datepicker:focus {
  width: min-content;
}
.muutoshakemus__current-project-end {
  height: 30px;
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./soresu-form/web/va/style/soresu-va.less","webpack://./va-hakija/web/va/muutoshakemus/components/jatkoaika/jatkoaika.less"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;ACDF;ADHA;EAMI,gBAAA;ACAJ;ADNA;EASI,qBAAA;EACA,kBAAA;ACAJ;ADCI;EACE,YAAA;ACCN;ADCI;EACE,YAAA;ACCN;ADIA;;EAEI,mBAAA;EACA,kBAAA;EACA,cAAA;ACFJ;ADFA;;EAOI,eAAA;ACDJ;ADKA;EACE,cAAA;ACHF;ADEA;;EAII,YAAA;EACA,gBAAA;ACFJ;ADHA;;EAOM,oBAAA;ACAN;ADPA;;EAUM,mBAAA;ACCN;ADXA;;EAaM,mBAAA;ACEN;ADfA;;EAiBQ,SAAA;EACA,YAAA;EACA,YAAA;ACER;ADrBA;;EAsBQ,aAAA;ACGR;ADzBA;;EA0BM,iBAAA;ACGN;AD7BA;;EA6BM,cAAA;ACIN;ADjCA;EAkCI,gBAAA;ACEJ;ADpCA;EAoCM,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;ACGN;AD1CA;EA4CQ,kCAAA;EACA,oCAAA;ACCR;AD9CA;EAkDQ,mBAAA;EACA,mBAAA;ACDR;ADlDA;EAwDQ,YAAA;ACHR;ADrDA;EA2DQ,YAAA;ACHR;ADxDA;EA8DQ,YAAA;ACHR;AD3DA;EAkEM,cAAA;ACJN;AD9DA;EAqEM,iBAAA;ACJN;ADjEA;EAwEM,6BAAA;EACA,iBAAA;ACJN;ADrEA;EA2EQ,gBAAA;ACHR;ADxEA;EAiFI,gBAAA;ACNJ;ADQI;EACE,gBAAA;ACNN;AD9EA;EAwFM,iBAAA;EACA,cAAA;ACPN;ADUI;EACE,WAAA;EACA,cAAA;ACRN;ADWI;EACE,YAAA;EACA,cAAA;ACTN;AD1FA;EAuGM,kBAAA;ACVN;AD7FA;EA2GM,iBAAA;ACXN;ADhGA;;EAiHU,YAAA;ACbV;ADpGA;;EAoHU,iBAAA;EACA,iBAAA;ACZV;ADzGA;;EA4HM,mBAAA;ACfN;AD7GA;;EAiIM,gBAAA;EACA,iBAAA;AChBN;ADlHA;EAsIM,SAAA;ACjBN;ADrHA;EAwIQ,SAAA;AChBR;ADkBM;EACE,iBAAA;EACA,gBAAA;AChBR;AD5HA;EAiJM,iBAAA;AClBN;AD/HA;EAqJM,iBAAA;ACnBN;ADwBA;EAEI,sBAAA;ACvBJ;AD2BI;EACE,cAAA;ACzBN;ADkBA;EAWM,WAAA;EACA,8BAAA;EACA,+BAAA;EACA,sBAAA;EACA,wBAAA;AC1BN;ADWA;;EAkBQ,uBAAA;ACzBR;ADOA;EAuBM,iBAAA;EACA,gBAAA;AC3BN;ADgCA;EAGM,sBAAA;AChCN;AD6BA;EAQQ,8BAAA;EACA,mBAAA;EACA,kBAAA;AClCR;ADwBA;EAgBM,eAAA;ACrCN;ADyCM;;;;;;;;;;;;EACE,WAAA;AC5BR;ADOA;EAyBM,cAAA;AC7BN;ADkCA;EACE,eAAA;EACA,YAAA;AChCF;AD8BA;EAKI,iBAAA;EACA,iBAAA;AChCJ;AA1NA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AA4NF;AAzNA;EACE,aAAA;AA2NF;AA5NA;EAII,mBAAA;AA2NJ;AA/NA;EAQI,8BAAA;EACA,kBAAA;AA0NJ;AAtNA;;;EAGE,kBAAA;AAwNF;AArNA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAuNF","sourcesContent":["@import \"~soresu-form/web/form/style/variables.less\";\n\n.change-request {\n  border: dotted @dark-gray;\n  border-width: 0 0 1px 0;\n  padding: 10px 0;\n  margin-bottom: 10px;\n  .change-request-title {\n    font-weight: 600;\n  }\n  .change-request-text {\n    white-space: pre-line;\n    font-style: italic;\n    &:before {\n      content: '\"';\n    }\n    &:after {\n      content: '\"';\n    }\n  }\n}\n\n.va-trainee-day-calculator, .va-trainee-day-calculator-total {\n  th {\n    font-weight: normal;\n    padding-right: 4px;\n    color: @form-label-black;\n  }\n  label.total {\n    display: inline;\n  }\n}\n\n.va-budget {\n  color: @form-label-black;\n\n  .summing-table, .budget-summary {\n    width: @section-width - 18px;\n    text-align: left;\n    tbody tr:last-child td {\n      padding-bottom: 10px;\n    }\n    .soresu-money-field input[type=text] {\n      margin: 0 6px 4px 0;\n    }\n    .soresu-text-field input[type=text] {\n      margin: 0 4px 4px 0;\n    }\n    .soresu-text-area {\n      textarea {\n        margin: 0;\n        width: ceil((@section-width / 2)) - 19px;\n        height: 24px;\n      }\n      .length-left {\n        display: none;\n      }\n    }\n    .money:after {\n      content: \"\\00A0€\";\n    }\n    .error {\n      color: @bright-red;\n    }\n  }\n\n  .summing-table {\n    margin-top: 13px;\n    caption {\n      margin: 8px 0 16px 0;\n      font-size: 18px;\n      text-align: left;\n      text-transform: uppercase;\n    }\n    thead {\n      tr {\n        // tr cannot have margin\n        border-top: 10px transparent solid;\n        border-bottom: 8px transparent solid;\n      }\n    }\n    tbody {\n      td {\n        vertical-align: top;\n        padding-bottom: 2px;\n      }\n    }\n    colgroup {\n      .label-column {\n        width: 415px;\n      }\n      .description-column {\n        width: 267px;\n      }\n      .amount-column {\n        width: 100px;\n      }\n    }\n    .label-column.disabled {\n      color: @darker-gray\n    }\n    .amount-column {\n      text-align: right;\n    }\n    tfoot {\n      border-top: 1px solid @light-gray;\n      font-weight: bold;\n      td {\n        padding-top: 5px;\n      }\n    }\n  }\n\n  .budget-summary {\n    margin-top: 26px;\n\n    &-financing {\n      overflow: hidden;  // clearfix\n    }\n\n    h4 {\n      font-weight: bold;\n      margin: 14px 0;\n    }\n\n    &-financing-left {\n      float: left;\n      max-width: 50%;\n    }\n\n    &-financing-right {\n      float: right;\n      max-width: 50%;\n    }\n\n    .amounts {\n      margin-right: 20px;\n    }\n\n    .percentages {\n      margin-left: 20px;\n    }\n\n    .amounts, .percentages {\n      tbody {\n        tr:first-child td {\n          height: 50px;\n        }\n        tr:last-child td {\n          padding-top: 10px;\n          padding-bottom: 0;\n        }\n      }\n    }\n\n    .amount-label-column,\n    .percentage-label-column {\n      padding-right: 20px;\n    }\n\n    .amount-value-column,\n    .percentage-value-column {\n      min-width: 120px;\n      text-align: right;\n    }\n\n    .soresu-money-field {\n      margin: 0;\n      input[type=text] {\n        margin: 0;\n      }\n      &:after {\n        content: \"\\00A0€\";\n        margin-left: 4px;\n      }\n    }\n\n    .percentage:after {\n      content: \"\\00A0%\";\n    }\n\n    .amount-value-column .money:not(.error):after {\n      margin-left: 12px;\n    }\n  }\n}\n\n.soresu-growing-fieldset {\n  ol li.va-big-fieldset {\n    margin: 20px 0 0 -90px;\n  }\n\n  .va-big-fieldset {\n    &.disabled {\n      color: @darker-gray;\n    }\n\n    div.fieldset-elements {\n      float: left;\n      border-left: 1px solid @dark-gray;\n      border-right: 1px solid @dark-gray;\n      padding: 0 10px 0 21px;\n      margin: 0 10px 40px 10px;\n\n      input[type=text], input[type=email] {\n        margin: 5px 10px 10px 0;\n      }\n    }\n\n    div.fieldset-control {\n      padding-top: 20px;\n      overflow: hidden;\n    }\n  }\n}\n\n.soresu-preview {\n  .soresu-preview-growing-fieldset {\n    ol li.va-big-fieldset {\n      margin: 0 0 40px -26px;\n    }\n\n    .va-big-fieldset {\n      div.fieldset-elements {\n        border-left: 1px solid @dark-gray;\n        padding: 0 0 0 21px;\n        margin: 0 0 0 20px;\n      }\n    }\n  }\n  .va-budget {\n    .soresu-value {\n      font-size: 16px;\n    }\n    .soresu-text-area,\n    .budget-summary .soresu-preview-element {\n      &.extra-extra-small, &.extra-small, &.small, &.medium, &.large, &.extra-large {\n        width: auto;\n      }\n    }\n    .budget-summary .amount-value-column .money:not(.error):after {\n      margin-left: 0;\n    }\n  }\n}\n\n.va-register-number {\n  margin-top: 5px;\n  float: right;\n\n  .title {\n    margin-right: 5px;\n    font-weight: bold;\n  }\n}\n","@import \"~soresu-form/web/va/style/soresu-va.less\";\n\n.h3 {\n  display: block;\n  margin-bottom: 1rem;\n  text-transform: uppercase;\n  letter-spacing: 0.01em;\n}\n\ndiv.twocolumns {\n  display: flex;\n\n  > div:first-child {\n    padding-right: 1rem;\n  }\n\n  > div:not(:first-child) {\n    border-left: 1px solid #979797;\n    padding-left: 1rem;\n  }\n}\n\n.datepicker,\n.datepicker:hover,\n.datepicker:focus {\n  width: min-content;\n}\n\n.muutoshakemus__current-project-end {\n  height: 30px;\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
